import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';

export default function useToken() {
	const router = useRouter();
	const [token, setToken] = useState(cookies.get(TOKEN_COOKIE_NAME));
	useEffect(() => {
		const token = cookies.get(TOKEN_COOKIE_NAME);
		if (!token || token === 'undefined') {
			cookies.remove(TOKEN_COOKIE_NAME);
		} else {
			setToken(token);
		}
	}, [router.pathname]);
	return token;
}
